enum EventMode {
  OnDemand = 'OnDemand',
  Online = 'Online',
  InPerson = 'InPerson',
}
export default EventMode;
